import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
 
@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('.');
      if (dateParts.length === 1 && parseInt(dateParts[0])) {
        return {day: parseInt(dateParts[0]), month: null, year: null};
      } else if (dateParts.length === 2 && dateParts[0] && dateParts[1]) {
        return {day: parseInt(dateParts[0]), month: parseInt(dateParts[1]), year: null};
      } else if (dateParts.length === 3 && dateParts[0] && dateParts[1] && dateParts[2]) {
        return {day: parseInt(dateParts[0]), month: parseInt(dateParts[1]), year: parseInt(dateParts[2])};
      }
    }
    return null;
  }
 
  format(date: NgbDateStruct): string {
    return date ?
        `${date.day ? date.day : ''}.${date.month ? date.month : ''}.${date.year}` :
        '';
  }
}